(function(){
  const MONEY = new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'});
  const FREE_SHIP_THRESHOLD = 50;
  const FLAT_SHIPPING = 8;
  const STORAGE_KEY = 'hhf-cart-v3';
  const SUBSCRIPTION_THEME_IDS = new Set(['130599059538']);
  const DISPLAY_ORDER = [
    'wildflower-honey',
    'cactus-honey',
    'mesquite-honey',
    'orange-blossom-honey',
    'alfalfa-honey',
    'suicide-honey',
    'dark-roast-honey',
    'light-roast-honey',
    'butter-toffee-honey',
    'hazelnut-honey',
    'pollen',
    'introduction-to-beekeeping-class',
    'introduction-to-beekeeping-classroom-only-copy',
    'introduction-to-beekeeping-hands-on-experience',
    'introduction-to-beekeeping-hands-on-experience-homeschool-students-families-only',
    'beekeeping-class-gift-certificate',
    'italian-nuc',
    'carniolan-nuc',
    'italian-queen',
    'italian-nuc-2025-queen',
    'vsh-italian-queen',
    'apitherapy-bees',
    'honey-hive-farms-gift-card',
    'payment-link-for-mcatee'
  ];
  const displayRank = new Map(DISPLAY_ORDER.map((handle, index) => [handle, index]));
  const products = (window.HHF_PRODUCTS || []).slice().sort((a, b) => {
    const aRank = displayRank.has(a.handle) ? displayRank.get(a.handle) : DISPLAY_ORDER.length;
    const bRank = displayRank.has(b.handle) ? displayRank.get(b.handle) : DISPLAY_ORDER.length;
    if(aRank !== bRank) return aRank - bRank;
    return text(a.title).localeCompare(text(b.title));
  });
  window.HHF_PRODUCTS = products;
  const PRODUCT_JSON_ORIGIN = window.HHF_PRODUCT_JSON_ORIGIN ||
    (((location.protocol === 'http:' || location.protocol === 'https:') &&
      (location.hostname === 'honeyhivefarms.com' || location.hostname.endsWith('.myshopify.com')))
      ? ''
      : 'https://honeyhivefarms.com');
  const PRODUCT_DETAIL_CONFIGS = window.HHF_PRODUCT_DETAILS || {};
  const DEFAULT_PRODUCT_PAGE_SETTINGS = {
    standardOptionLabel: 'Size',
    giftOptionLabel: 'Amount',
    classOptionLabel: 'Choose a date',
    detailMode: 'auto',
    badgeLabel: '',
    breadcrumbLabel: 'Shop',
    breadcrumbUrl: '/shop',
    taxNote: 'Plus estimated tax',
    addButtonLabel: 'Add to cart',
    registerButtonLabel: 'Register',
    subscriptionNote: 'Subscription billing is handled securely by Shopify at checkout.'
  };
  const STALE_FARM_STAND_COPY = 'The farm stand is Saturday 10 AM to 1 PM; online orders ship unless Honey Hive Farms confirms a shipping.';
  const FARM_STAND_COPY = 'Farm stand: Saturdays 10 AM–1 PM at 14611 N. 83rd Ave. Online orders ship as soon as possible. Free shipping on orders $50+.';

  function money(n){ return MONEY.format(Number(n||0)); }
  function text(s){ return String(s||'').replace(/\s+/g,' ').trim(); }
  function clean(s){
    return text(String(s||'')
      .replace(/<[^>]*>/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .replace(/https?:\/\/\S+/g, ''));
  }

  function parseProductPageSettings(){
    const node = document.querySelector('[data-product-page-settings]');
    if(!node) return {};
    try {
      return JSON.parse(node.textContent || '{}') || {};
    } catch (error) {
      console.warn('[HHF] Unable to parse product page settings', error);
      return {};
    }
  }

  function productPageSettings(){
    if(!productPageSettings.cache){
      productPageSettings.cache = { ...DEFAULT_PRODUCT_PAGE_SETTINGS, ...parseProductPageSettings() };
    }
    return productPageSettings.cache;
  }

  function productDetailConfig(p){
    return {
      ...(p?.detail_config || {}),
      ...(PRODUCT_DETAIL_CONFIGS[p?.handle] || {})
    };
  }

  function configuredValue(value, fallback = ''){
    const normalized = text(value);
    return normalized || fallback;
  }

  function normalizedProductType(p){
    return text(p?.product_type || p?.type).toLowerCase();
  }

  function isGiftProduct(p){
    const handle = String(p?.handle || '');
    const type = normalizedProductType(p);
    return type === 'gift card' || type === 'gift certificate' || handle.includes('gift-card') || handle.includes('gift-certificate');
  }

  function productDetailMode(p){
    const configured = configuredValue(productDetailConfig(p).mode).toLowerCase();
    if(configured) return configured;
    const sectionMode = configuredValue(productPageSettings().detailMode).toLowerCase();
    if(sectionMode && sectionMode !== 'auto') return sectionMode;
    const type = normalizedProductType(p);
    if(isGiftProduct(p)) return 'gift-card';
    if(type === 'beekeeping class') return 'class';
    return 'standard';
  }

  function productOptionLabel(p){
    const settings = productPageSettings();
    const configured = configuredValue(productDetailConfig(p).optionLabel);
    if(configured) return configured;
    if(productDetailMode(p) === 'class') return settings.classOptionLabel;
    if(isGiftProduct(p)) return settings.giftOptionLabel;
    return settings.standardOptionLabel;
  }

  function productTaxNote(p){
    return configuredValue(productDetailConfig(p).taxNote, productPageSettings().taxNote);
  }

  function productAddButtonLabel(p){
    const configured = configuredValue(productDetailConfig(p).addButtonLabel);
    if(configured) return configured;
    return productDetailMode(p) === 'class'
      ? productPageSettings().registerButtonLabel
      : productPageSettings().addButtonLabel;
  }

  function productBadgeLabel(p){
    const configured = configuredValue(productDetailConfig(p).badgeLabel);
    if(configured) return configured;
    const sectionBadge = configuredValue(productPageSettings().badgeLabel);
    if(sectionBadge && sectionBadge.toLowerCase() !== 'auto') return sectionBadge;
    return categoryPill(p);
  }

  function productBreadcrumb(){
    const settings = productPageSettings();
    return {
      label: configuredValue(settings.breadcrumbLabel, 'Shop'),
      url: configuredValue(settings.breadcrumbUrl, '/shop')
    };
  }

  const honeyHandles = new Set(
    products.filter(p => normalizedProductType(p) === 'honey' && !isGiftProduct(p))
      .map(p => p.handle)
  );
  function isHoney(p){ return honeyHandles.has(p.handle); }

  function genericChoices(p){
    return (p.variants||[]).filter(v=>v.available).map(v=>({
      key: String(v.id),
      label: v.title === 'Default Title' ? p.title : v.title,
      variant: v,
      price: Number(v.price||0),
      order: 0
    }));
  }

  function productChoices(p){
    return genericChoices(p);
  }

  function choiceByKey(p, key){
    const list = productChoices(p);
    return list.find(c => String(c.key) === String(key)) || list[0];
  }

  const byHandle = Object.fromEntries(products.map(p => [p.handle, p]));

  function isClassProduct(p){ return p && productDetailMode(p) === 'class'; }

  function productJsonUrl(handle){
    return `${PRODUCT_JSON_ORIGIN}/products/${encodeURIComponent(handle)}.js`;
  }

  function normalizeImage(src){
    if(!src) return '';
    const value = typeof src === 'string' ? src : (src.src || src.url || '');
    if(!value) return '';
    if(value.startsWith('//')) return `https:${value}`;
    return value;
  }

  function imageDedupeKey(src){
    if(!src) return '';
    try {
      const url = new URL(src, location.origin);
      return url.pathname;
    } catch {
      return String(src).split('?')[0];
    }
  }

  function normalizeLiveVariant(variant){
    const cents = Number(variant.price || 0);
    return {
      id: variant.id,
      title: variant.title,
      option1: variant.option1,
      option2: variant.option2,
      option3: variant.option3,
      available: variant.available !== false,
      price: cents / 100,
      sku: variant.sku || '',
      grams: Number(variant.grams || variant.weight || 0),
      selling_plan_allocations: Array.isArray(variant.selling_plan_allocations) ? variant.selling_plan_allocations : []
    };
  }

  function applyLiveProduct(target, liveProduct){
    const variants = (liveProduct.variants || [])
      .filter(variant => variant.available !== false)
      .map(normalizeLiveVariant);
    const prices = variants.map(variant => Number(variant.price || 0));
    const image = normalizeImage(liveProduct.featured_image || liveProduct.image);
    const images = (liveProduct.images || []).map(normalizeImage).filter(Boolean);

    target.title = liveProduct.title || target.title;
    target.description = target.description || liveProduct.description;
    target.vendor = liveProduct.vendor || target.vendor;
    target.product_type = liveProduct.type || liveProduct.product_type || target.product_type;
    if(image && !target.image && !target.photoImage){
      target.image = image;
      target.photoImage = image;
    }
    target.images = target.images?.length ? target.images : images;
    target.variants = variants;
    target.selling_plan_groups = Array.isArray(liveProduct.selling_plan_groups) ? liveProduct.selling_plan_groups : [];
    target.available = Boolean(liveProduct.available && variants.length);
    target.price_min = prices.length ? Math.min(...prices) : 0;
    target.price_max = prices.length ? Math.max(...prices) : 0;
    target.__liveHydrated = true;
  }

  async function refreshProduct(product){
    const response = await fetch(productJsonUrl(product.handle), { headers: { Accept: 'application/json' } });
    if(!response.ok) throw new Error(`Unable to load ${product.handle}: ${response.status}`);
    applyLiveProduct(product, await response.json());
  }

  async function hydrateProducts(){
    const staleProducts = products.filter(product =>
      !product.__liveHydrated ||
      (isHoney(product) && !Array.isArray(product.selling_plan_groups))
    );
    if(!staleProducts.length || typeof fetch !== 'function') return;
    await Promise.all(staleProducts.map(product =>
      refreshProduct(product).catch(error => {
        console.warn('[HHF] Using cached product data', product.handle, error);
      })
    ));
  }

  function photoImage(p){ return p.photoImage || p.image || ''; }
  function drawingImage(p){
    return (p.drawingImage || '').replace('https://honeyhivefarms.com/cdn/shop/', 'https://shop.honeyhivefarms.com/cdn/shop/');
  }
  function primaryImage(p){ return drawingImage(p) || photoImage(p); }
  function usesContainedProductImage(p){
    return [
      'dark-roast-honey',
      'light-roast-honey',
      'butter-toffee-honey',
      'hazelnut-honey'
    ].includes(p.handle);
  }

  function esc(s){
    return String(s || '').replace(/[&<>"']/g, ch => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[ch]);
  }

  function navProductCard(p){
    const href = productPath(p.handle);
    return `<a class="nav-photo-card" href="${href}">
      <span class="nav-photo-img"><img src="${esc(primaryImage(p))}" alt="${esc(p.title)}" loading="lazy" decoding="async"></span>
      <span class="nav-photo-label">${esc(p.title)}</span>
    </a>`;
  }

  const deliveryAreas = [
    ['Arizona', '/arizona-honey'],
    ['Peoria', '/peoria-honey'],
    ['Glendale', '/glendale-honey'],
    ['Sun City', '/sun-city-honey'],
    ['Surprise', '/surprise-honey'],
    ['West Wing', '/west-wing-honey'],
    ['Phoenix', '/phoenix-honey'],
    ['Arcadia', '/arcadia-honey'],
    ['Desert Ridge', '/desert-ridge-honey'],
    ['Scottsdale', '/scottsdale-honey'],
    ['Paradise Valley', '/paradise-valley-honey'],
    ['Tempe', '/tempe-honey'],
    ['Mesa', '/mesa-honey'],
    ['Chandler', '/chandler-honey'],
    ['Gilbert', '/gilbert-honey'],
    ['Litchfield Park', '/litchfield-park-honey'],
    ['Goodyear', '/goodyear-honey'],
    ['Tucson', '/tucson-honey'],
    ['Flagstaff', '/flagstaff-honey']
  ];

  function renderSharedNav(){
    const nav = document.querySelector('[data-nav-menu]');
    if(!nav || nav.dataset.enhanced === 'true') return;

    const shopCards = products.filter(isHoney).slice(0, 6).map(navProductCard).join('');
    const areaLinks = deliveryAreas.map(([label, href]) =>
      `<a class="nav-area-link" href="${nativePath(href)}">${esc(label)}</a>`
    ).join('') + '<a class="nav-area-link nav-area-details" href="/pages/delivery">All delivery details</a>';

    nav.innerHTML = `
      <div class="nav-photo-wrap">
        <a class="nav-link" href="/shop">Shop</a>
        <div class="nav-photo-panel" aria-label="Featured honey">
          <div class="container nav-photo-inner">
            <div class="nav-photo-grid">${shopCards}</div>
            <a class="nav-photo-all" href="/shop">Shop all honey</a>
          </div>
        </div>
      </div>
      <a class="nav-link" href="/pages/classes">Classes</a>
      <a class="nav-link" href="/blogs/news">The Buzz</a>
      <div class="nav-photo-wrap nav-area-wrap">
        <a class="nav-link" href="/pages/delivery">Delivery</a>
        <div class="nav-area-panel" aria-label="Delivery areas">
          <div class="container nav-area-inner">
            <div class="nav-area-copy">
              <span class="nav-area-kicker">Delivery areas</span>
              <strong>Arizona honey by city</strong>
              <p>Raw Arizona honey by area, with current ordering and shipping details.</p>
            </div>
            <div class="nav-area-grid">${areaLinks}</div>
          </div>
        </div>
      </div>
      <a class="nav-link" href="/pages/faq">FAQ</a>
      <a class="nav-link" href="/pages/about">About</a>`;
	  nav.dataset.enhanced = 'true';

	  nav.querySelectorAll('.nav-photo-wrap').forEach((wrap) => {
	    const panel = wrap.querySelector('.nav-photo-panel, .nav-area-panel');
	    let closeTimer;
	    const open = () => {
	      clearTimeout(closeTimer);
	      wrap.classList.add('is-open');
	    };
	    const closeSoon = () => {
	      clearTimeout(closeTimer);
	      closeTimer = setTimeout(() => wrap.classList.remove('is-open'), 260);
	    };

	    wrap.addEventListener('mouseenter', open);
	    wrap.addEventListener('mouseleave', closeSoon);
	    wrap.addEventListener('focusin', open);
	    wrap.addEventListener('focusout', closeSoon);
	    panel?.addEventListener('mouseenter', open);
	    panel?.addEventListener('mouseleave', closeSoon);
	  });
	  }

  function normalizeFarmStandCopy(){
    document.querySelectorAll('.location-note').forEach(note => {
      if(text(note.textContent).includes(STALE_FARM_STAND_COPY)){
        note.textContent = FARM_STAND_COPY;
      }
    });
  }

  function priceRange(p){
    const list = productChoices(p);
    if(!list.length) return '';
    const prices = list.map(c => c.price);
    const min = Math.min(...prices), max = Math.max(...prices);
    return min === max ? money(min) : `${money(min)}–${money(max)}`;
  }

  function loadCart(){ try{return JSON.parse(localStorage.getItem(STORAGE_KEY)||'[]')}catch(e){return []} }
  function saveCart(c){ localStorage.setItem(STORAGE_KEY, JSON.stringify(c)); }

  function lineFor(item){
    const p = byHandle[item.handle];
    if(!p) return null;
    const c = choiceByKey(p, item.choiceKey);
    if(!c) return null;
    const sellingPlan = sellingPlans(p).find(plan => String(plan.id) === String(item.sellingPlanId || ''));
    const subscriptionUnit = sellingPlan ? subscriptionPrice(c, sellingPlan.id) : null;
    return {
      product:p,
      choice:c,
      qty:Math.max(1,Number(item.qty||1)),
      unit: subscriptionUnit || c.price,
      variantId: c.variant?.id,
      sellingPlan
    };
  }

  function cartLines(){ return loadCart().map(lineFor).filter(Boolean); }
  function cartCount(){ return cartLines().reduce((s,l)=>s+l.qty,0); }
  function cartSubtotal(){ return cartLines().reduce((s,l)=>s+l.qty*l.unit,0); }
  function productShipsWithFlatRate(product){ return product?.handle !== 'pollen'; }
  function shipsWithFlatRate(line){ return productShipsWithFlatRate(line?.product); }
  function shippingSubtotal(lines){ return lines.reduce((s,l)=>s+(shipsWithFlatRate(l) ? l.qty*l.unit : 0),0); }
  function shippingFor(sub){ return sub <= 0 ? 0 : (sub >= FREE_SHIP_THRESHOLD ? 0 : FLAT_SHIPPING); }
  function shippingMessage(sub){
    if(sub <= 0) return 'Pollen is excluded from flat-rate shipping.';
    if(sub >= FREE_SHIP_THRESHOLD) return 'Free shipping unlocked.';
    const need = Math.max(0, FREE_SHIP_THRESHOLD - sub);
    return `${money(FLAT_SHIPPING)} flat shipping. Add ${money(need)} more for free shipping.`;
  }
  function productShippingMessage(product, choice, qty = 1){
    if(!productShipsWithFlatRate(product)) return 'Pollen is excluded from flat-rate shipping.';
    const selectedChoice = choice || productChoices(product)[0];
    const quantity = Math.max(1, Number(qty || 1));
    return shippingMessage(selectedChoice ? selectedChoice.price * quantity : 0);
  }
  function productFormShippingMessage(form){
    const product = byHandle[form?.getAttribute('data-handle') || ''];
    if(!product) return '';
    const choice = choiceByKey(product, form.querySelector('[data-choice]')?.value);
    const qty = form.querySelector('[data-qty]')?.value || 1;
    return productShippingMessage(product, choice, qty);
  }
  function updateProductShippingCopy(form){
    const copy = form?.querySelector('[data-shipping-copy]');
    if(copy) copy.textContent = productFormShippingMessage(form);
  }

  function categoryPill(p){
    const type = normalizedProductType(p);
    if(isGiftProduct(p)) return 'Gift card';
    if(type === 'beekeeping class') return 'Class';
    if(['bees', 'queen bee', 'nuc', 'package bees'].includes(type)) return 'Bees';
    if(p.handle === 'pollen') return 'Pollen';
    if(type === 'honey') return 'Raw honey';
    const firstCollection = productCollections(p)[0];
    if(firstCollection?.title) return firstCollection.title;
    if(p.product_type) return p.product_type;
    return 'Raw honey';
  }

  function prettifyHandle(handle){
    return text(handle).split('-').filter(Boolean).map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(' ');
  }

  function normalizedCollection(collection){
    if(typeof collection === 'string'){
      const handle = text(collection).toLowerCase();
      return handle ? { handle, title: prettifyHandle(handle) } : null;
    }
    const handle = text(collection?.handle).toLowerCase();
    if(!handle) return null;
    return {
      handle,
      title: text(collection?.title) || prettifyHandle(handle)
    };
  }

  function productCollections(p){
    const collections = Array.isArray(p?.collections)
      ? p.collections
      : (Array.isArray(productDetailConfig(p).collections) ? productDetailConfig(p).collections : []);
    const seen = new Set();
    return collections
      .map(normalizedCollection)
      .filter(Boolean)
      .filter(collection => {
        if(seen.has(collection.handle)) return false;
        seen.add(collection.handle);
        return true;
      });
  }

  function productCategories(p){
    const values = productCollections(p).map(collection => collection.handle);
    if(values.length) return values;
    if(Array.isArray(p?.categories)) return p.categories.map(value => text(value)).filter(Boolean);
    return [p?.category].map(value => text(value)).filter(Boolean);
  }

  function hasProductCategory(p, category){
    return productCategories(p).includes(category);
  }

  function nativePath(path) {
    if (!path || path.charAt(0) !== '/') return path;
    if (path === '/shop') return '/shop';
    if (path === '/the-buzz') return '/blogs/news';
    if (path.indexOf('/the-buzz/') === 0) return `/blogs/news/${path.replace(/^\/the-buzz\//, '').replace(/\/$/, '')}`;
    if (
      path === '/' ||
      path.indexOf('/products/') === 0 ||
      path.indexOf('/collections/') === 0 ||
      path.indexOf('/cart') === 0 ||
      path.indexOf('/search') === 0 ||
      path.indexOf('/account') === 0 ||
      path.indexOf('/checkout') === 0 ||
      path.indexOf('/policies/') === 0
    ) return path;
    return `/pages${path.replace(/\/$/, '')}`;
  }

  function productPath(handle){ return `/products/${encodeURIComponent(handle)}`; }

  function filterCategory(p){
    return productCategories(p)[0] || 'other';
  }

  function availableShopFilters(){
    const filters = new Map();
    products.forEach(product => {
      productCollections(product).forEach(collection => {
        if(!filters.has(collection.handle)) filters.set(collection.handle, collection);
      });
    });
    return Array.from(filters.values());
  }

  function renderProductFilters(){
    const filters = document.querySelector('[data-product-filters]');
    if(!filters) return;
    const shopFilters = availableShopFilters();
    const allLabel = configuredValue(filters.dataset.filterAllLabel, 'All');
    filters.innerHTML = [
      `<button type="button" data-filter="all" class="active">${esc(allLabel)}</button>`,
      ...shopFilters.map(filter => `<button type="button" data-filter="${esc(filter.handle)}">${esc(filter.title)}</button>`)
    ].join('');
  }

  function drawingCue(p){
    const cueMap = {
      'wildflower-honey': 'WF',
      'cactus-honey': 'CA',
      'mesquite-honey': 'ME',
      'orange-blossom-honey': 'OB',
      'alfalfa-honey': 'AL',
      'suicide-honey': 'SU',
      'dark-roast-honey': 'DR',
      'light-roast-honey': 'LR',
      'butter-toffee-honey': 'BT',
      'hazelnut-honey': 'HZ',
      'pollen': 'PO',
      'honey-hive-farms-gift-card': 'GC',
      'beekeeping-class-gift-certificate': 'GC',
      'italian-nuc-2025-queen': 'NUC',
      'italian-nuc': 'NUC',
      'italian-queen': 'Q'
    };
    const cleanTitle = text(p.title)
      .replace(/Honey Hive Farms/ig, '')
      .replace(/\bHoney\b/ig, '')
      .replace(/\bIntroduction to\b/ig, '')
      .replace(/\bBeekeeping\b/ig, 'Bee')
      .replace(/\s+/g, ' ')
      .trim();
    const words = cleanTitle.split(/\s+/).filter(Boolean);
    const initials = cueMap[p.handle] || words.slice(0, 2).map(w => w[0]).join('').toUpperCase() || 'HH';
    const label = cleanTitle || p.title;
    return { initials, label };
  }

  function drawingMarkup(p){
    const drawing = drawingImage(p);
    if(drawing){
      return `<span class="card-drawing card-drawing-image" aria-label="${esc(p.title)} label drawing">
        <img src="${esc(drawing)}" alt="${esc(p.title)} label drawing" loading="lazy" decoding="async">
      </span>`;
    }
    return '';
  }

  function optionMarkup(p){
    return productChoices(p).map(c =>
      `<option value="${String(c.key).replace(/"/g,'&quot;')}">${c.label} — ${money(c.price)}</option>`
    ).join('');
  }

  function sellingPlans(p){
    if(!subscriptionsEnabled()) return [];
    return (p.selling_plan_groups || [])
      .flatMap(group => (group.selling_plans || []).map(plan => ({
        ...plan,
        groupName: group.name || 'Subscription'
      })))
      .filter(plan => plan && plan.id);
  }

  function subscriptionsEnabled(){
    const shopify = window.Shopify || {};
    const theme = shopify.theme || {};
    return SUBSCRIPTION_THEME_IDS.has(String(theme.id || ''));
  }

  function firstSellingPlan(p){
    return sellingPlans(p)[0] || null;
  }

  function sellingPlanAllocation(choice, planId){
    return (choice?.variant?.selling_plan_allocations || [])
      .find(allocation => String(allocation.selling_plan_id) === String(planId));
  }

  function subscriptionPrice(choice, planId){
    const allocation = sellingPlanAllocation(choice, planId);
    if(!allocation) return null;
    const cents = Number(allocation.price || allocation.per_delivery_price || 0);
    return Number.isFinite(cents) && cents > 0 ? cents / 100 : null;
  }

  function purchaseOptionMarkup(p, selectedChoice){
    const plan = firstSellingPlan(p);
    if(!plan) return '';
    const planPrice = subscriptionPrice(selectedChoice, plan.id);
    const priceCopy = planPrice ? `${money(planPrice)} per delivery` : 'Subscription price shown at checkout';
    return `<fieldset class="purchase-options" data-purchase-options>
      <legend>Purchase option</legend>
      <label class="purchase-option active">
        <input type="radio" name="purchase_option_${esc(p.handle)}" value="one-time" data-purchase-option checked>
        <span>
          <strong>One-time purchase</strong>
          <small>Order this honey once.</small>
        </span>
      </label>
      <label class="purchase-option">
        <input type="radio" name="purchase_option_${esc(p.handle)}" value="${esc(plan.id)}" data-purchase-option>
        <span>
          <strong>${esc(plan.name || 'Deliver every month')}</strong>
          <small>${esc(priceCopy)}. Skip, pause, or cancel from the customer account.</small>
        </span>
      </label>
    </fieldset>`;
  }

  function syncPurchaseOptionState(form){
    const p = byHandle[form?.getAttribute('data-handle') || ''];
    if(!p) return;
    const choice = choiceByKey(p, form.querySelector('[data-choice]')?.value);
    const plan = firstSellingPlan(p);
    form.querySelectorAll('.purchase-option').forEach(label => {
      label.classList.toggle('active', Boolean(label.querySelector('[data-purchase-option]:checked')));
    });
    const subscriptionInput = form.querySelector('[data-purchase-option][value]:not([value="one-time"])');
    const subscriptionCopy = subscriptionInput?.closest('.purchase-option')?.querySelector('small');
    if(plan && subscriptionCopy){
      const planPrice = subscriptionPrice(choice, plan.id);
      subscriptionCopy.textContent = `${planPrice ? `${money(planPrice)} per delivery` : 'Subscription price shown at checkout'}. Skip, pause, or cancel from the customer account.`;
    }
  }

  function productCard(p){
    const sold = !p.available || !productChoices(p).length;
    const desc = clean(p.description).slice(0, 100);
    const shortDesc = desc + (desc.length < clean(p.description).length ? '…' : '');
    const drawing = drawingMarkup(p);
    const mediaClass = [
      'card-media',
      drawing ? '' : 'card-media-photo-only',
      usesContainedProductImage(p) ? 'card-media-contained' : ''
    ].filter(Boolean).join(' ');
    const categories = productCategories(p);
    const categoryData = categories.length ? categories.join(' ') : filterCategory(p);
    return `<article class="card" data-category="${filterCategory(p)}" data-categories="${esc(categoryData)}" data-title="${p.title.toLowerCase()}">
      <a class="${mediaClass}" href="${productPath(p.handle)}" aria-label="View ${p.title}">
        <img src="${esc(photoImage(p))}" alt="${esc(p.title)}" loading="lazy" decoding="async">
        ${drawing}
      </a>
      <div class="card-body">
        <div class="card-meta">
          <span class="pill">${categoryPill(p)}</span>
          <span class="card-price">${sold ? 'Sold out' : priceRange(p)}</span>
        </div>
        <h3 class="card-title"><a href="${productPath(p.handle)}">${p.title}</a></h3>
        <p class="card-desc">${shortDesc}</p>
        ${sold ? '<p class="card-status">Currently sold out</p>' : `
        <form class="card-form" data-product-form data-handle="${p.handle}" onsubmit="return false">
          <label class="visually-hidden" for="size-${p.handle}">Size</label>
          <select id="size-${p.handle}" class="select" data-choice>${optionMarkup(p)}</select>
          <div class="qty-row">
            <div class="qty-stepper" data-stepper>
              <button type="button" class="qty-btn" data-qty-dec aria-label="Decrease quantity">−</button>
              <input type="number" class="qty-input" data-qty min="1" value="1" inputmode="numeric" aria-label="Quantity">
              <button type="button" class="qty-btn" data-qty-inc aria-label="Increase quantity">+</button>
            </div>
            <button type="button" class="btn btn-primary" data-add>Add to cart</button>
          </div>
        </form>`}
      </div>
    </article>`;
  }

  function renderProductGrids(){
    document.querySelectorAll('[data-product-grid]').forEach(grid=>{
      const mode = grid.getAttribute('data-product-grid');
      let list = products;
      if(mode === 'featured'){
        list = products.filter(isHoney);
      } else if(mode === 'shop'){
        list = products;
      } else if(mode === 'honey'){
        list = products.filter(isHoney);
      } else if(mode === 'classes'){
        list = products.filter(p => hasProductCategory(p, 'beekeeping-classes'));
      } else if(mode === 'gift-card'){
        list = products.filter(p => hasProductCategory(p, 'need-a-gift'));
      } else if(mode === 'bees'){
        list = products.filter(p => hasProductCategory(p, 'queens-nucs'));
      } else if(mode.indexOf('collection:') === 0){
        list = products.filter(p => hasProductCategory(p, mode.replace(/^collection:/, '')));
      }
      const limit = Number(grid.getAttribute('data-product-limit'));
      if(Number.isFinite(limit) && limit > 0){
        list = list.slice(0, limit);
      }
      grid.innerHTML = list.map(productCard).join('');
    });
    applyProductVisibility();
  }

  function applyProductVisibility(){
    const activeFilter = document.querySelector('[data-filter].active')?.getAttribute('data-filter') || 'all';
    const searchTerm = document.querySelector('[data-product-search]')?.value.trim().toLowerCase() || '';

    document.querySelectorAll('.card[data-category]').forEach(card => {
      const categories = (card.getAttribute('data-categories') || card.getAttribute('data-category') || '').split(/\s+/).filter(Boolean);
      const categoryMatch = activeFilter === 'all' || categories.includes(activeFilter);
      const searchMatch = !searchTerm || card.getAttribute('data-title').includes(searchTerm);
      card.style.display = categoryMatch && searchMatch ? '' : 'none';
    });

    document.querySelectorAll('[data-product-grid]').forEach(grid => {
      const hasVisibleCards = Array.from(grid.querySelectorAll('.card[data-category]')).some(card => card.style.display !== 'none');
      grid.hidden = !hasVisibleCards;
    });
  }

  function setActiveProductFilter(filter){
    const validFilter = document.querySelector(`[data-filter="${filter}"]`) ? filter : 'all';
    document.querySelectorAll('[data-filter]').forEach(b => {
      b.classList.toggle('active', b.getAttribute('data-filter') === validFilter);
    });
    return validFilter;
  }

  function applyProductFilterFromUrl(){
    const params = new URLSearchParams(location.search);
    setActiveProductFilter(params.get('category') || params.get('filter') || 'all');
  }

  function syncFilterUrl(filter){
    const url = new URL(location.href);
    if(filter === 'all') url.searchParams.delete('category');
    else url.searchParams.set('category', filter);
    url.searchParams.delete('filter');
    history.replaceState(null, '', url);
  }

  function renderProductPage(){
    const mount = document.querySelector('[data-product-page]');
    if(!mount) return;
    const params = new URLSearchParams(location.search);
    const productPathMatch = location.pathname.match(/\/products\/([^/?#]+)/);
    const pathHandle = productPathMatch ? decodeURIComponent(productPathMatch[1]) : '';
    const handle = params.get('handle') || pathHandle || 'wildflower-honey';
    const p = byHandle[handle] || byHandle['wildflower-honey'];
    document.title = `${p.title} — Honey Hive Farms`;

    if(productDetailMode(p) === 'class'){ renderClassDetail(p, mount); return; }

    const desc = clean(p.description);
    const breadcrumb = productBreadcrumb();
    const selectedChoice = productChoices(p)[0];
    const initialShippingCopy = productShippingMessage(p, selectedChoice);
    const optionLabel = productOptionLabel(p);
    const taxNote = productTaxNote(p);
    const addButtonLabel = productAddButtonLabel(p);
    const subscriptionNote = productPageSettings().subscriptionNote;
    const heroImage = primaryImage(p);
    const photo = photoImage(p);
    const seenGalleryImages = new Set();
    const gallery = [heroImage, photo, ...(p.images||[])]
      .filter(src => {
        const key = imageDedupeKey(src);
        if(!key || seenGalleryImages.has(key)) return false;
        seenGalleryImages.add(key);
        return true;
      })
      .slice(0,4);
    mount.innerHTML = `
      <nav class="breadcrumb"><a href="${esc(breadcrumb.url)}">${esc(breadcrumb.label)}</a> <span>/</span> <span>${p.title}</span></nav>
      <div class="product-detail">
        <div class="product-gallery">
          <img class="product-hero-img${drawingImage(p) ? ' product-hero-img-drawing' : ''}" src="${esc(heroImage)}" alt="${esc(p.title)}" loading="eager" fetchpriority="high" decoding="async" data-product-hero-image>
          ${gallery.length > 1 ? `<div class="thumb-row" aria-label="${esc(p.title)} images">${gallery.map((src, index)=>`<button type="button" class="thumb-btn${index === 0 ? ' active' : ''}" data-gallery-src="${esc(src)}" data-gallery-drawing="${src === drawingImage(p) ? 'true' : 'false'}" aria-label="View ${esc(p.title)} image ${index + 1}" aria-pressed="${index === 0 ? 'true' : 'false'}"><img src="${esc(src)}" alt="" loading="lazy" decoding="async"></button>`).join('')}</div>` : ''}
        </div>
        <div class="product-info">
          <div class="badge-row">
            <span class="pill">${esc(productBadgeLabel(p))}</span>
            ${p.available ? '<span class="pill pill-ok">In stock</span>' : '<span class="pill pill-out">Sold out</span>'}
          </div>
          <h1 class="product-title">${p.title}</h1>
          <div class="product-price">${priceRange(p)}</div>
          ${taxNote ? `<div class="product-tax-note">${esc(taxNote)}</div>` : ''}
          <p class="product-desc">${desc}</p>
          ${p.available && productChoices(p).length ? `
          <form class="buy-form" data-product-form data-handle="${p.handle}" onsubmit="return false">
            <label class="field-label" for="detail-size">${esc(optionLabel)}</label>
            <select id="detail-size" class="select select-lg" data-choice>${optionMarkup(p)}</select>
            ${purchaseOptionMarkup(p, selectedChoice)}
            <div class="qty-row qty-row-lg">
              <div class="qty-stepper" data-stepper>
                <button type="button" class="qty-btn" data-qty-dec aria-label="Decrease quantity">−</button>
                <input type="number" class="qty-input" data-qty min="1" value="1" inputmode="numeric" aria-label="Quantity">
                <button type="button" class="qty-btn" data-qty-inc aria-label="Increase quantity">+</button>
              </div>
              <button type="button" class="btn btn-primary btn-lg" data-add>${esc(addButtonLabel)}</button>
            </div>
            <div class="ship-note" data-shipping-copy>${esc(initialShippingCopy)}</div>
            ${firstSellingPlan(p) && subscriptionNote ? `<div class="ship-note subscription-note">${esc(subscriptionNote)}</div>` : ''}
          </form>` : '<p class="notice">This item is currently sold out.</p>'}
        </div>
      </div>`;
    bindProductGallery(mount);
  }

  function bindProductGallery(mount){
    const hero = mount.querySelector('[data-product-hero-image]');
    const thumbs = Array.from(mount.querySelectorAll('[data-gallery-src]'));
    if(!hero || !thumbs.length) return;

    const showImage = (thumb) => {
      const src = thumb.getAttribute('data-gallery-src');
      if(!src) return;
      hero.src = src;
      hero.classList.toggle('product-hero-img-drawing', thumb.getAttribute('data-gallery-drawing') === 'true');
      thumbs.forEach(btn => {
        const active = btn === thumb;
        btn.classList.toggle('active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    thumbs.forEach(thumb => {
      thumb.addEventListener('mouseenter', () => showImage(thumb));
      thumb.addEventListener('focus', () => showImage(thumb));
      thumb.addEventListener('click', () => showImage(thumb));
      thumb.addEventListener('keydown', event => {
        if(event.key === 'Enter' || event.key === ' '){
          event.preventDefault();
          showImage(thumb);
        }
      });
    });
  }

  function classDetail(p){
    const raw = clean(p.description);
    const parts = raw.split(/IMPORTANT:\s*/i);
    return { main: parts[0].trim(), note: parts[1] ? 'IMPORTANT: ' + parts[1].trim() : '' };
  }

  function renderClassDetail(p, mount){
    const {main, note} = classDetail(p);
    const optionLabel = productOptionLabel(p);
    const addButtonLabel = productAddButtonLabel(p);
    const breadcrumb = productBreadcrumb();
    mount.innerHTML = `
      <nav class="breadcrumb"><a href="${esc(breadcrumb.url)}">${esc(breadcrumb.label)}</a> <span>/</span> <span>${p.title}</span></nav>
      <div class="product-detail">
        <div class="product-gallery"><img class="product-hero-img" src="${esc(photoImage(p))}" alt="${esc(p.title)}" loading="eager" fetchpriority="high" decoding="async"></div>
        <div class="product-info">
          <div class="badge-row"><span class="pill">${esc(productBadgeLabel(p) || 'Hands-on class')}</span>${p.available?'<span class="pill pill-ok">Registration open</span>':'<span class="pill pill-out">Closed</span>'}</div>
          <h1 class="product-title">${p.title}</h1>
          <p class="product-desc">${main}</p>
          ${note ? `<div class="info-note">${note}</div>` : ''}
          ${p.available && (p.variants||[]).filter(v=>v.available).length ? `
          <form class="buy-form" data-product-form data-handle="${p.handle}" onsubmit="return false">
            <label class="field-label" for="class-date">${esc(optionLabel)}</label>
            <select id="class-date" class="select select-lg" data-choice>${optionMarkup(p)}</select>
            <div class="qty-row qty-row-lg">
              <div class="qty-stepper" data-stepper>
                <button type="button" class="qty-btn" data-qty-dec aria-label="Decrease seats">−</button>
                <input type="number" class="qty-input" data-qty min="1" value="1" inputmode="numeric" aria-label="Seats">
                <button type="button" class="qty-btn" data-qty-inc aria-label="Increase seats">+</button>
              </div>
              <button type="button" class="btn btn-primary btn-lg" data-add>${esc(addButtonLabel)}</button>
            </div>
          </form>` : '<p class="notice">Registration is currently closed for this class.</p>'}
        </div>
      </div>`;
  }

  function renderCart(){
    const lines = cartLines();
    const sub = cartSubtotal();
    const shipSub = shippingSubtotal(lines);
    const ship = shippingFor(shipSub);
    const pct = Math.min(100, shipSub === 0 ? 0 : (shipSub / FREE_SHIP_THRESHOLD) * 100);
    const count = lines.reduce((s,l)=>s+l.qty,0);
    const shipCopy = shippingMessage(shipSub);

    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.classList.toggle('has-items', count > 0);
    });
    document.querySelectorAll('[data-meter-fill]').forEach(el => el.style.width = pct + '%');
    document.querySelectorAll('[data-meter-copy]').forEach(el => {
      el.textContent = shipCopy;
    });
    document.querySelectorAll('[data-shipping-copy]').forEach(el => {
      const form = el.closest('[data-product-form]');
      el.textContent = form ? productFormShippingMessage(form) : shipCopy;
    });

    document.querySelectorAll('[data-cart-items]').forEach(el => {
      if(!lines.length){
        el.innerHTML = `<div class="cart-empty"><p>Your cart is empty.</p><a class="btn btn-primary" href="/shop">Shop honey</a></div>`;
        return;
      }
      el.innerHTML = lines.map((l, i) => `
        <div class="cart-item">
          <img src="${esc(primaryImage(l.product))}" alt="${esc(l.product.title)}" loading="lazy" decoding="async">
          <div class="cart-item-body">
            <div class="cart-item-title">${l.product.title}</div>
            <div class="cart-item-sub">${l.choice.label}</div>
            ${l.sellingPlan ? `<div class="cart-item-sub">${esc(l.sellingPlan.name || 'Subscription')}</div>` : ''}
            <div class="cart-item-price">${money(l.unit)} each</div>
            <div class="cart-item-qty">
              <button type="button" class="qty-btn" data-cart-dec="${i}" aria-label="Decrease">−</button>
              <input type="number" class="qty-input" data-cart-qty="${i}" min="1" value="${l.qty}">
              <button type="button" class="qty-btn" data-cart-inc="${i}" aria-label="Increase">+</button>
              <button type="button" class="cart-remove" data-cart-remove="${i}">Remove</button>
            </div>
          </div>
          <div class="cart-item-total">${money(l.unit * l.qty)}</div>
        </div>`).join('');
    });

    document.querySelectorAll('[data-cart-subtotal]').forEach(el => el.textContent = money(sub));
    document.querySelectorAll('[data-cart-shipping]').forEach(el => el.textContent = ship === 0 ? (shipSub > 0 ? 'Free' : '—') : money(ship));
    document.querySelectorAll('[data-cart-total]').forEach(el => el.textContent = money(sub + ship));
    document.querySelectorAll('.cart-foot').forEach(foot => {
      if(!foot.querySelector('[data-cart-tax-note]')){
        const totalLine = foot.querySelector('.cart-line.total');
        totalLine?.insertAdjacentHTML('afterend', '<div class="cart-tax-note" data-cart-tax-note></div>');
      }
    });
    document.querySelectorAll('[data-cart-tax-note]').forEach(el => {
      el.textContent = lines.length ? 'Plus estimated tax' : '';
    });
    document.querySelectorAll('[data-checkout]').forEach(b => b.disabled = !lines.length);
  }

  function selectedSellingPlan(form){
    const value = form?.querySelector('[data-purchase-option]:checked')?.value || '';
    return value && value !== 'one-time' ? value : '';
  }

  function addToCart(handle, choiceKey, qty, sellingPlanId = ''){
    const cart = loadCart();
    qty = Math.max(1, Number(qty || 1));
    const existing = cart.find(i =>
      i.handle === handle &&
      String(i.choiceKey) === String(choiceKey) &&
      String(i.sellingPlanId || '') === String(sellingPlanId || '')
    );
    if(existing) existing.qty = Number(existing.qty || 0) + qty;
    else cart.push({ handle, choiceKey, qty, sellingPlanId });
    saveCart(cart);
    renderCart();
    openCart();
  }

  function openCart(){
    document.querySelector('[data-cart-drawer]')?.classList.add('open');
    document.querySelector('[data-cart-backdrop]')?.classList.add('open');
    document.body.classList.add('no-scroll');
  }
  function closeCart(){
    document.querySelector('[data-cart-drawer]')?.classList.remove('open');
    document.querySelector('[data-cart-backdrop]')?.classList.remove('open');
    document.body.classList.remove('no-scroll');
  }

  async function checkout(){
    const lines = cartLines();
    if(!lines.length) return;
    const items = lines
      .filter(line => line.variantId)
      .map(line => ({
        id: line.variantId,
        quantity: line.qty,
        ...(line.sellingPlan ? { selling_plan: line.sellingPlan.id } : {})
      }));
    if(!items.length) return;

    try {
      await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if(!response.ok) throw new Error(`Cart add failed: ${response.status}`);
      window.location.href = '/checkout';
    } catch (error) {
      console.warn('[HHF] Checkout failed, falling back to cart permalink when possible', error);
      const hasSubscription = lines.some(line => line.sellingPlan);
      if(hasSubscription){
        document.querySelectorAll('[data-cart-tax-note]').forEach(el => {
          el.textContent = 'Checkout could not start. Please try again in a moment.';
        });
        return;
      }
      const grouped = new Map();
      lines.forEach(l => {
        if(!l.variantId || l.sellingPlan) return;
        grouped.set(l.variantId, (grouped.get(l.variantId)||0) + l.qty);
      });
      if(!grouped.size) return;
      const path = Array.from(grouped.entries()).map(([id, q]) => `${id}:${q}`).join(',');
      window.location.href = `/cart/${path}`;
    }
  }

  function ensureBottomBar(){
    if(document.querySelector('[data-bottom-cart-bar]')) return;
    const bar = document.createElement('div');
    bar.className = 'bottom-cart-bar';
    bar.setAttribute('data-bottom-cart-bar', '');
    bar.innerHTML = `
      <div class="bottom-cart-inner">
        <div class="bottom-copy">
          <strong>Free shipping at $50+</strong>
          <span data-meter-copy>$8.00 flat shipping. Add $50.00 more for free shipping.</span>
        </div>
        <div class="bottom-meter" aria-label="Free shipping progress">
          <div class="meter-fill" data-meter-fill></div>
        </div>
        <button class="btn btn-primary bottom-cart-button" type="button" data-open-cart>
          Cart <span data-cart-count>0</span>
        </button>
      </div>`;
    document.body.appendChild(bar);
  }

  function syncBottomBar(){
    const existing = document.querySelector('[data-bottom-cart-bar]');
    const showBottomBar = window.matchMedia('(min-width: 768px)').matches;
    if(!showBottomBar){
      existing?.remove();
      return;
    }
    ensureBottomBar();
  }

  function getStepperInput(stepper){ return stepper.querySelector('[data-qty]') || stepper.querySelector('[data-cart-qty]'); }

  document.addEventListener('click', e => {
    const add = e.target.closest('[data-add]');
    if(add){
      const form = add.closest('[data-product-form]');
      const handle = form.getAttribute('data-handle');
      const choice = form.querySelector('[data-choice]').value;
      const qty = form.querySelector('[data-qty]').value;
      addToCart(handle, choice, qty, selectedSellingPlan(form));
      return;
    }
    const purchase = e.target.closest('[data-purchase-option]');
    if(purchase){
      syncPurchaseOptionState(purchase.closest('[data-product-form]'));
      return;
    }
    const dec = e.target.closest('[data-qty-dec]');
    if(dec){
      const stepper = dec.closest('[data-stepper]');
      const input = stepper.querySelector('[data-qty]');
      input.value = Math.max(1, Number(input.value || 1) - 1);
      updateProductShippingCopy(input.closest('[data-product-form]'));
      return;
    }
    const inc = e.target.closest('[data-qty-inc]');
    if(inc){
      const stepper = inc.closest('[data-stepper]');
      const input = stepper.querySelector('[data-qty]');
      input.value = Math.max(1, Number(input.value || 1) + 1);
      updateProductShippingCopy(input.closest('[data-product-form]'));
      return;
    }
    const cdec = e.target.closest('[data-cart-dec]');
    if(cdec){
      const i = Number(cdec.getAttribute('data-cart-dec'));
      const cart = loadCart();
      if(cart[i]){ cart[i].qty = Math.max(1, Number(cart[i].qty||1) - 1); saveCart(cart); renderCart(); }
      return;
    }
    const cinc = e.target.closest('[data-cart-inc]');
    if(cinc){
      const i = Number(cinc.getAttribute('data-cart-inc'));
      const cart = loadCart();
      if(cart[i]){ cart[i].qty = Number(cart[i].qty||1) + 1; saveCart(cart); renderCart(); }
      return;
    }
    const rem = e.target.closest('[data-cart-remove]');
    if(rem){
      const i = Number(rem.getAttribute('data-cart-remove'));
      const cart = loadCart(); cart.splice(i, 1); saveCart(cart); renderCart();
      return;
    }
    if(e.target.closest('[data-open-cart]')) { openCart(); return; }
    if(e.target.closest('[data-close-cart]') || e.target.matches('[data-cart-backdrop]')) { closeCart(); return; }
    if(e.target.closest('[data-checkout]')) { checkout(); return; }

    const filter = e.target.closest('[data-filter]');
    if(filter){
      const activeFilter = setActiveProductFilter(filter.getAttribute('data-filter'));
      syncFilterUrl(activeFilter);
      applyProductVisibility();
      return;
    }

    const navTog = e.target.closest('[data-nav-toggle]');
    if(navTog){
      document.querySelector('[data-nav-menu]')?.classList.toggle('open');
      navTog.classList.toggle('open');
      return;
    }
  });

  document.addEventListener('input', e => {
    const cq = e.target.closest('[data-cart-qty]');
    if(cq){
      const i = Number(cq.getAttribute('data-cart-qty'));
      const cart = loadCart();
      if(cart[i]){ cart[i].qty = Math.max(1, Number(cq.value || 1)); saveCart(cart); renderCart(); }
    }
    const choice = e.target.closest('[data-choice]');
    if(choice){
      const form = choice.closest('[data-product-form]');
      syncPurchaseOptionState(form);
      updateProductShippingCopy(form);
    }
    const qty = e.target.closest('[data-qty]');
    if(qty){
      updateProductShippingCopy(qty.closest('[data-product-form]'));
    }
    const search = e.target.closest('[data-product-search]');
    if(search){
      applyProductVisibility();
    }
  });

  document.addEventListener('keydown', e => { if(e.key === 'Escape') closeCart(); });

  async function restorePeoriaCityPage() {
    if (window.location.pathname !== '/pages/peoria-honey') return;
    if (document.querySelector('.city-page-section')) return;
    const main = document.querySelector('#MainContent');
    if (!main) return;
    try {
      const response = await fetch('/pages/peoria-honey?view=hhfv3cityfix610', { credentials: 'same-origin' });
      if (!response.ok) return;
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const restored = doc.querySelector('#MainContent');
      if (!restored || !restored.querySelector('.city-page-section')) return;
      main.innerHTML = restored.innerHTML;
      normalizeFarmStandCopy();
      renderSharedNav();
      renderCart();
    } catch (error) {
      console.warn('Unable to restore Peoria city page', error);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    normalizeFarmStandCopy();
    renderSharedNav();
    restorePeoriaCityPage();
    hydrateProducts().finally(() => {
      normalizeFarmStandCopy();
      renderProductFilters();
      renderProductGrids();
      applyProductFilterFromUrl();
      applyProductVisibility();
      renderProductPage();
      syncBottomBar();
      renderCart();
    });
  });

  window.addEventListener('resize', () => {
    syncBottomBar();
    renderCart();
  });
})();
